export default __webpack_public_path__ + "static/media/chain-link-icon.8c6b9fbe.svg";